// Shared utilities for cached RTK Query selector fallbacks.
// Ensures stable object references so React-Redux does not warn about selectors
// returning new references for identical input state.

export interface UninitializedQueryResult {
  readonly data: undefined;
  readonly status: 'uninitialized';
}

// Frozen constant guarantees referential stability.
export const UNINITIALIZED_QUERY_RESULT: UninitializedQueryResult =
  Object.freeze({
    data: undefined,
    status: 'uninitialized',
  });

// Stable selector function that always returns the same object reference.
export const EMPTY_SELECTOR = () => UNINITIALIZED_QUERY_RESULT;
